window.jQuery = window.$ = $;

require('jquery-migrate');

jQuery.migrateMute = false;
require('jquery-ui');
require('jquery-ui/ui/widgets/sortable');
require('jquery-ui/ui/disable-selection');
require('jquery-ui/ui/widgets/tooltip');
require('jquery-ui/ui/widgets/button');
require('jquery-ui/ui/widgets/mouse');
require('jquery-ui-touch-punch');
// Handle jQuery plugin naming conflict between jQuery UI and Bootstrap
// From: https://stackoverflow.com/a/19247955
$.widget.bridge('uibutton', $.ui.button);
$.widget.bridge('uitooltip', $.ui.tooltip);

require('bootstrap');

window.Cookies = require('js-cookie');



// WEBPACK FOOTER //
// ./src-assets/js/ui-tools.js